<template>
  <v-container fluid class="grey lighten-2">
    <v-row>
      <v-col class="mt-2" cols="12">
        <v-dialog v-model="dialog" max-width="800" scrollable persistent transition="dialog-bottom-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on">
              <v-icon id="life_insurance">{{ icon }}</v-icon>{{ phrase.title_life_insurance }}
            </v-btn>
          </template>

          <v-card height=400>
            <v-card-title class="text-h5 grey lighten-2">{{ phrase.title_life_insurance }}</v-card-title>
            <v-card-text style="white-space: pre-line">
              <div class="my-5 text--primary">{{ help_life_insurance_text }}</div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="justify-start">
              <v-btn color="primary" text @click="dialog = false">
                {{ phrase.dialog_close }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <span class="ml-4 font-weight-bold header-total-inline">合計 {{ (this.$store.state.breakdown.life_insurance_you + this.$store.state.breakdown.life_insurance_spouse).toLocaleString() }}円</span>
      </v-col>
      <v-col class="mt-2" cols="12">
        <v-img max-height="80" max-width="150" contain v-bind:src="require('@/assets/gibraltar.jpg')" v-if="this.$store.state.login_response.queryStringParameters.target == 'sendai' || this.$store.state.login_response.queryStringParameters.target == 'shinagawa'"></v-img>
      </v-col>
      <v-col>
        <v-sheet
          color="grey lighten-2"
          elevation="10"
        >
          <v-col>
            <v-switch v-model="isShowYou" prepend-icon="mdi-eye" inset hide-details></v-switch>
            <p v-show="isShowYou">
            あなた<v-select class="d-inline-flex align-center mt-2 ml-4" :items=this.$store.state.login_response.life_insurance_you item-text="select" return-object :label="$store.state.select.life_insurance.you" @change="value_life_insurance_you"></v-select>
            </p>
          </v-col>
          <v-col>
            <v-row>
              <v-col class="mt-2 d-flex" cols="12" sm="4" md="3" lg="3" v-for="you in this.$store.state.login_response.life_insurance_you" :key="you.key">
                <v-card class="d-flex flex-column flex-grow-1">
                  <v-card-text>
                    <v-simple-table>
                      <thead></thead>
                      <tbody>
                        <tr>
                          <td>性別</td>
                          <td v-if="you.gender == 1">男性</td>
                          <td v-else>女性</td>
                        </tr>
                        <tr>
                          <td>年齢</td>
                          <td>{{ you.age }}歳</td>
                        </tr>
                        <tr>
                          <td>保険金</td>
                          <td>{{ you.insurance.toLocaleString() }}万円</td>
                        </tr>
                        <tr>
                          <td>保険料</td>
                          <td>{{ you.premium.toLocaleString() }}円</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <div v-if="this.$store.state.login_response.persona.is_married">
            <v-col>
              <v-switch v-model="isShowSpouse" prepend-icon="mdi-eye" inset hide-details></v-switch>
              <p v-show="isShowSpouse">
              配偶者<v-select class="d-inline-flex align-center mt-2 ml-4" clearable :items=this.$store.state.login_response.life_insurance_spouse item-text="select" return-object :label="$store.state.select.life_insurance.spouse" @change="value_life_insurance_spouse"></v-select>
              </p>
            </v-col>
            <v-col>
              <v-row>
                <v-col class="mt-2 d-flex" cols="12" sm="4" md="3" lg="3"  v-for="spouse in this.$store.state.login_response.life_insurance_spouse" :key="spouse.key">
                  <v-card class="d-flex flex-column flex-grow-1">
                    <v-card-text>
                      <v-simple-table>
                        <thead></thead>
                        <tbody>
                          <tr>
                            <td>性別</td>
                            <td v-if="spouse.gender == 1">男性</td>
                            <td v-else>女性</td>
                          </tr>
                          <tr>
                            <td>年齢</td>
                            <td>{{ spouse.age }}歳</td>
                          </tr>
                          <tr>
                            <td>保険金</td>
                            <td>{{ spouse.insurance.toLocaleString() }}万円</td>
                          </tr>
                          <tr>
                            <td>保険料</td>
                            <td>{{ spouse.premium.toLocaleString() }}円</td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import words from '../assets/words.json'

export default({
  data() {
    return {
      icon: 'mdi-lifebuoy',
      isShowYou: true,
      isShowSpouse: true,
      dialog: false,
      phrase: {}
    }
  },
  mounted: function () {
    this.getWords()
  },
  computed: {
    help_life_insurance_text () {
      return this.phrase.help_life_insurance
    }
  },
  methods: {
    value_life_insurance_you: function(value) {
      this.$store.commit('value_life_insurance_you', value);
      this.$store.commit('rebalance');
      this.$store.commit('set_progress');
    },
    value_life_insurance_spouse: function(value) {
      // When the select is cleared, Vuetify emits null. Treat it as "no insurance" (0 yen).
      const v = value || { select: '加入しない', premium: 0, insurance: 0 }
      this.$store.commit('value_life_insurance_spouse', v)
      this.$store.commit('rebalance')
      this.$store.commit('set_progress')
    },
    getWords: function () {
      this.phrase = words
    }
  },
})
</script>
